import React from 'react';
import PropTypes from 'prop-types';
import { animated } from 'react-spring';

import { getCourseColor, getCourseIconPath } from '../../../utils/course-utils';

const CourseMobile = props => {
  return (
    <animated.div
      style={{ ...props.style, background: getCourseColor(props.course.type) }}
      className="m-courses-carousel-content"
    >
      <img src={getCourseIconPath(props.course.type)} width={75} height={75} className="my-15px" />
      <p className="m-courses-carousel-content-title">{props.course.name}</p>
      <p className="m-courses-carousel-content-text my-15px">{props.course.description}</p>
    </animated.div>
  );
};

CourseMobile.propTypes = {
  style: PropTypes.object.isRequired,
  course: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    type: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
};

export default CourseMobile;
